import issuerMessageModule from "./issuerMessage/issuerMessageModule.js"

const shortResumeModule = {
    namespaced: true,
    state: {},
    actions: {},
    modules: {
        issuer: issuerMessageModule
    }
}

export default shortResumeModule